import React, {ReactNode} from 'react';

import {Menu} from '@reach/menu-button';

import '@reach/menu-button/styles.css';
import {ReactComponent as ArrowDownIcon} from 'assets/svg/arrow-bottom.svg';
import {ReactComponent as ArrowUpIcon} from 'assets/svg/arrow-up.svg';

import {ButtonVariant} from '../Button';

import {
    List,
    Item,
    CustomButton,
    CustomMenuButton,
    CustomIcon,
    CustomButtonDiv,
    LoadingSpinner,
} from './styled';

interface Props {
    children: ReactNode;
    label: string;
    width?: string | number;
    noIcon?: boolean;
    buttonVariant?: ButtonVariant;
    buttonSize?: 'sm' | 'md' | 'lg';
    disabled?: boolean;
    isLoading?: boolean;
}

export class DropdownMenu extends React.Component<Props> {
    public static List = List;

    public static Item = Item;

    render() {
        const {
            children,
            label,
            width,
            noIcon = false,
            buttonVariant,
            buttonSize = 'sm',
            disabled = false,
            isLoading = false,
        } = this.props;

        const styledChildren = React.Children.map(children, (child) => {
            if (React.isValidElement(child) && child.type === List) {
                return React.cloneElement(child, {
                    style: {width, ...(child.props.style || {})},
                });
            }
            return child;
        });

        return (
            <Menu>
                {({isExpanded}) => (
                    <>
                        <CustomMenuButton disabled={disabled || isLoading}>
                            {noIcon ? (
                                <CustomButtonDiv
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                >
                                    {label}
                                </CustomButtonDiv>
                            ) : (
                                <CustomButton
                                    variant={buttonVariant}
                                    size={buttonSize}
                                    isExpanded={isExpanded}
                                    style={{whiteSpace: 'nowrap'}}
                                    disabled={disabled || isLoading}
                                >
                                    {label}
                                    {isLoading ? (
                                        <LoadingSpinner color="primary" />
                                    ) : (
                                        <CustomIcon
                                            source={isExpanded ? ArrowUpIcon : ArrowDownIcon}
                                            width={14}
                                            height={14}
                                        />
                                    )}
                                </CustomButton>
                            )}
                        </CustomMenuButton>
                        {styledChildren}
                    </>
                )}
            </Menu>
        );
    }
}
